import { PATH_PREFIX, PRODUCT_APPLN_ID } from 'utils/constants'; 

const routes = [
    { 
        name:'dashboard',
        path:PATH_PREFIX+'dashboard',
        samplePath:PATH_PREFIX+'dashboard',
        componentId:'dashboard',
        title:'leftmenu.dashboard',
        exact:true,
        access:['admin', 'user']
    },
    { 
        name:'export',
        path:PATH_PREFIX+'export',
        samplePath:PATH_PREFIX+'export',
        componentId:'emaillinkhandler',
        title:'export',
        exact:true,
        access:['admin', 'user']
    },
    {
        name:'products',
        path:PATH_PREFIX+'products',
        samplePath:PATH_PREFIX+'products',
        componentId:'products/products',
        title:'leftmenu.products',
        exact:true,
        access:['admin', 'user'],
    },
    { 
        name:'addeditproduct',
        path:PATH_PREFIX+'products/addeditproduct/:parent_o_id/:language_code/:mode',
        samplePath:PATH_PREFIX+'products/addeditproduct/-1/en/view',
        componentId:'products/addeditproduct',
        title: function(){return app.pageInfo.params['parent_o_id'] == -1? 'addproduct':'editproduct'},
        exact:false,
        access:['admin', 'user']
    },

    {
        name:'productapplication',
        path:PATH_PREFIX+'productapplication',
        samplePath:PATH_PREFIX+'productapplication',
        componentId:'productapplication/productapplication',
        title:'leftmenu.product_application',
        exact:true,
        access:['admin', 'user'] 
    },
    { 
        name:'addeditproductappln',
        path:PATH_PREFIX+'productappln/addeditproductappln/:productApplicationId/:productApplicationLang',
        samplePath:PATH_PREFIX+'productappln/addeditproductappln/-1/en',
        componentId:'productapplication/addeditproductappln',
        title: function(){return app.pageInfo.params["productApplicationId"] == -1? 'addproductappln':'editproductappln'},
        exact:false,
        access:['admin', 'user']
    },  
    {
        name:'myaccount',
        path:PATH_PREFIX+'myaccount',
        samplePath:PATH_PREFIX+'myaccount',
        componentId:'profile/myaccount',
        title:'leftmenu.myaccount',
        exact:true,
        access:['admin', 'user'],
        resourceCode:"MY_ACCOUNT"
    }, 
     
    { 
        name:'bulkupload',
        path:PATH_PREFIX+'upload/bulkupload/:type',
        samplePath:PATH_PREFIX+'upload/bulkupload/products',
        componentId:'upload/bulkupload',
        title: function(){return app.pageInfo.params['type'] == "productApplication" ? 'upload_'+app.pageInfo.params['type'].toLowerCase(): 'upload'},
        exact:true,
        access:['admin', 'user']
    }, 
    { 
        name:'scheduleexport',
        path:PATH_PREFIX+'scheduleexport',
        samplePath:PATH_PREFIX+'scheduleexport',
        componentId:'scheduleexport/scheduleExportBase',
        title:'leftmenu.schedule_export',
        exact:true,
        access:['user']
    },
    { 
        name:'addeditexports',
        path:PATH_PREFIX+'scheduleexport/addeditexports/:export_schedule_id',
        samplePath:PATH_PREFIX+'scheduleexport/addeditexports/1234',
        componentId:'scheduleexport/addEditExports',
        title: function(){return app.pageInfo.params['export_schedule_id'] == -1? 'add_new_schedule_export':'edit_new_schedule_export'},
        exact:false,
        access:['user']
    },
    {
        name:'notification',
        path:PATH_PREFIX+'notification',
        samplePath:PATH_PREFIX+'notification',
        componentId:'notification',
        title:'notification',
        exact:true,
        access:['admin', 'user']
    },
    { 
        name:'medialibrary',
        path:PATH_PREFIX+'medialibrary',
        samplePath:PATH_PREFIX+'medialibrary',
        componentId:'medialibrarymain/mediaLibraryBase',
        title:'leftmenu.media_library',
        exact:true,
        access:['user', 'admin']
    },

    {
        name:'productgroup',
        path:PATH_PREFIX+'productgroup',
        samplePath:PATH_PREFIX+'productgroup',
        componentId:'productgroup/productgroup',
        title:'leftmenu.product_group',
        exact:true,
        access:['admin', 'user'] 
    },
    { 
        name:'addeditproductgroup',
        path:PATH_PREFIX+'productgroup/addeditproductgroup/:productGroupId',
        samplePath:PATH_PREFIX+'productgroup/addeditproductgroup/-1/en',
        componentId:'productgroup/addeditproductgroup',
        title: function(){return app.pageInfo.params["productGroupId"] == -1? 'addproductgroup':'editproductgroup'},
        exact:false,
        access:['admin', 'user']
    },
    { 
        name:'templates',
        path:PATH_PREFIX+'templates',
        samplePath:PATH_PREFIX+'templates',
        componentId:'templates/template',
        title:'leftmenu.templates',
        exact: true,
        access:['user', 'admin']
    },
    { 
        name:'customactions',
        path:PATH_PREFIX+'actions',
        samplePath:PATH_PREFIX+'actions',
        componentId:'actions/actions',
        title:'leftmenu.actions',
        exact: true,
        access:['user', 'admin']
    }
];

export default routes;

